// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file user.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserRole, UserRoleJson, UserStatus, UserStatusJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, ListInfo, ListInfoJson, ResponseStatus, ResponseStatusJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file user.proto.
 */
export const file_user: GenFile = /*@__PURE__*/
  fileDesc("Cgp1c2VyLnByb3RvEglyYWNjb29uYWkimAQKBFVzZXISCgoCaWQYASACKAQSIQoEcm9sZRgCIAIoDjITLnJhY2Nvb25haS5Vc2VyUm9sZRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAyABKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIeCgpmaXJzdF9uYW1lGAQgASgJUgpmaXJzdF9uYW1lEhwKCWxhc3RfbmFtZRgFIAEoCVIJbGFzdF9uYW1lEiIKDHBob25lX251bWJlchgGIAEoCVIMcGhvbmVfbnVtYmVyEg0KBWVtYWlsGAcgASgJEiUKBnN0YXR1cxgIIAIoDjIVLnJhY2Nvb25haS5Vc2VyU3RhdHVzEjQKFWRyaXZlcl9saWNlbnNlX251bWJlchgJIAEoCVIVZHJpdmVyX2xpY2Vuc2VfbnVtYmVyEhwKCWZjbV90b2tlbhgKIAEoCVIJZmNtX3Rva2VuEkcKEm93bmVyX29yZ2FuaXphdGlvbhgLIAEoCzIXLnJhY2Nvb25haS5Pcmdhbml6YXRpb25SEm93bmVyX29yZ2FuaXphdGlvbhI6CgpjcmVhdGVkX2F0GGUgAigLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKY3JlYXRlZF9hdBI6Cgp1cGRhdGVkX2F0GGYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcFIKdXBkYXRlZF9hdCLsAgoKVXNlckNyZWF0ZRIhCgRyb2xlGAEgAigOMhMucmFjY29vbmFpLlVzZXJSb2xlEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAEoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkEh4KCmZpcnN0X25hbWUYAyABKAlSCmZpcnN0X25hbWUSHAoJbGFzdF9uYW1lGAQgASgJUglsYXN0X25hbWUSIgoMcGhvbmVfbnVtYmVyGAUgASgJUgxwaG9uZV9udW1iZXISDQoFZW1haWwYBiABKAkSEAoIcGFzc3dvcmQYByACKAkSNAoVZHJpdmVyX2xpY2Vuc2VfbnVtYmVyGAggASgJUhVkcml2ZXJfbGljZW5zZV9udW1iZXISHAoJZmNtX3Rva2VuGAkgASgJUglmY21fdG9rZW4SLgoScmVnaXN0cmF0aW9uX3Rva2VuGAogASgJUhJyZWdpc3RyYXRpb25fdG9rZW4i3QIKClVzZXJVcGRhdGUSCgoCaWQYASACKAQSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAIgASgEUhVvd25lcl9vcmdhbml6YXRpb25faWQSHgoKZmlyc3RfbmFtZRgDIAEoCVIKZmlyc3RfbmFtZRIcCglsYXN0X25hbWUYBCABKAlSCWxhc3RfbmFtZRIiCgxwaG9uZV9udW1iZXIYBSABKAlSDHBob25lX251bWJlchINCgVlbWFpbBgGIAEoCRIlCgZzdGF0dXMYByABKA4yFS5yYWNjb29uYWkuVXNlclN0YXR1cxI0ChVkcml2ZXJfbGljZW5zZV9udW1iZXIYCCABKAlSFWRyaXZlcl9saWNlbnNlX251bWJlchIcCglmY21fdG9rZW4YCSABKAlSCWZjbV90b2tlbhIhCgRyb2xlGAogASgOMhMucmFjY29vbmFpLlVzZXJSb2xlIj8KDlVzZXJVcGRhdGVSb2xlEgoKAmlkGAEgAigEEiEKBHJvbGUYAiACKA4yEy5yYWNjb29uYWkuVXNlclJvbGUidwoPVXNlclBhc3N3b3JkU2V0EgoKAmlkGAEgAigEEjQKFW93bmVyX29yZ2FuaXphdGlvbl9pZBgCIAIoBFIVb3duZXJfb3JnYW5pemF0aW9uX2lkEiIKDG5ld19wYXNzd29yZBgDIAIoCVIMbmV3X3Bhc3N3b3JkIocCChdSZWdpc3RyYXRpb25Ub2tlbkNyZWF0ZRINCgV0b2tlbhgBIAIoCRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIhCgRyb2xlGAMgAigOMhMucmFjY29vbmFpLlVzZXJSb2xlEjoKCmV4cGlyZXNfYXQYBCACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpleHBpcmVzX2F0Ei4KEmNyZWF0ZWRfYnlfdXNlcl9pZBgFIAIoBFISY3JlYXRlZF9ieV91c2VyX2lkEhgKB2lzX3VzZWQYBiABKAhSB2lzX3VzZWQiPwoXUmVnaXN0cmF0aW9uVG9rZW5VcGRhdGUSCgoCaWQYASACKAQSGAoHaXNfdXNlZBgCIAIoCFIHaXNfdXNlZCK0AQoMR2VuZXJhdGVMaW5rEiEKBHJvbGUYASACKA4yEy5yYWNjb29uYWkuVXNlclJvbGUSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAIgAigFUhVvd25lcl9vcmdhbml6YXRpb25faWQSKgoQcHJlZmVycmVkX21ldGhvZBgDIAIoCVIQcHJlZmVycmVkX21ldGhvZBIRCglyZWNpcGllbnQYBCACKAkSDAoEbGFuZxgFIAIoCSJQCg5QYXNzd29yZFVwZGF0ZRIKCgJpZBgBIAIoBBIYCgdvbGRfcHdkGAIgAigJUgdvbGRfcHdkEhgKB25ld19wd2QYAyACKAlSB25ld19wd2QizwEKD1VzZXJMaXN0UmVxdWVzdBIiCgVyb2xlcxgBIAMoDjITLnJhY2Nvb25haS5Vc2VyUm9sZRInCghzdGF0dXNlcxgCIAMoDjIVLnJhY2Nvb25haS5Vc2VyU3RhdHVzEjYKFm93bmVyX29yZ2FuaXphdGlvbl9pZHMYAyADKARSFm93bmVyX29yZ2FuaXphdGlvbl9pZHMSNwoLbGlzdF9maWx0ZXIYCiABKAsyFS5yYWNjb29uYWkuTGlzdEZpbHRlclILbGlzdF9maWx0ZXIiXQoIVXNlckxpc3QSHgoFdXNlcnMYASADKAsyDy5yYWNjb29uYWkuVXNlchIxCglsaXN0X2luZm8YAiABKAsyEy5yYWNjb29uYWkuTGlzdEluZm9SCWxpc3RfaW5mbyLVAQoRSW52aXRlVXNlclJlcXVlc3QSIQoEcm9sZRgBIAIoDjITLnJhY2Nvb25haS5Vc2VyUm9sZRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYAiACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBJGChBwcmVmZXJyZWRfbWV0aG9kGAMgAigOMhoucmFjY29vbmFpLlByZWZlcnJlZE1ldGhvZFIQcHJlZmVycmVkX21ldGhvZBIRCglyZWNpcGllbnQYBCACKAkSDAoEbGFuZxgFIAIoCSJvChJJbnZpdGVVc2VyUmVzcG9uc2USKQoGc3RhdHVzGAEgAigOMhkucmFjY29vbmFpLlJlc3BvbnNlU3RhdHVzEi4KEnJlZ2lzdHJhdGlvbl90b2tlbhgCIAIoCVIScmVnaXN0cmF0aW9uX3Rva2VuKocBCg9QcmVmZXJyZWRNZXRob2QSHgoaUFJFRkVSUkVEX01FVEhPRF9VTkRFRklORUQQABIdChlQUkVGRVJSRURfTUVUSE9EX1dIQVRTQVBQEAESGgoWUFJFRkVSUkVEX01FVEhPRF9FTUFJTBACEhkKFVBSRUZFUlJFRF9NRVRIT0RfQ09QWRADQgZaBC4vcGI", [file_enums, file_general, file_google_protobuf_timestamp, file_organization]);

/**
 * @generated from message raccoonai.User
 */
export type User = Message<"raccoonai.User"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required raccoonai.UserRole role = 2;
   */
  role: UserRole;

  /**
   * @generated from field: optional uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string first_name = 4 [json_name = "first_name"];
   */
  firstName: string;

  /**
   * @generated from field: optional string last_name = 5 [json_name = "last_name"];
   */
  lastName: string;

  /**
   * @generated from field: optional string phone_number = 6 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 7;
   */
  email: string;

  /**
   * @generated from field: required raccoonai.UserStatus status = 8;
   */
  status: UserStatus;

  /**
   * @generated from field: optional string driver_license_number = 9 [json_name = "driver_license_number"];
   */
  driverLicenseNumber: string;

  /**
   * @generated from field: optional string fcm_token = 10 [json_name = "fcm_token"];
   */
  fcmToken: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 11 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.User
 */
export type UserJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required raccoonai.UserRole role = 2;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: optional uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string first_name = 4 [json_name = "first_name"];
   */
  first_name?: string;

  /**
   * @generated from field: optional string last_name = 5 [json_name = "last_name"];
   */
  last_name?: string;

  /**
   * @generated from field: optional string phone_number = 6 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 7;
   */
  email?: string;

  /**
   * @generated from field: required raccoonai.UserStatus status = 8;
   */
  status?: UserStatusJson;

  /**
   * @generated from field: optional string driver_license_number = 9 [json_name = "driver_license_number"];
   */
  driver_license_number?: string;

  /**
   * @generated from field: optional string fcm_token = 10 [json_name = "fcm_token"];
   */
  fcm_token?: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 11 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User, {jsonType: UserJson}> = /*@__PURE__*/
  messageDesc(file_user, 0);

/**
 * @generated from message raccoonai.UserCreate
 */
export type UserCreate = Message<"raccoonai.UserCreate"> & {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role: UserRole;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string first_name = 3 [json_name = "first_name"];
   */
  firstName: string;

  /**
   * @generated from field: optional string last_name = 4 [json_name = "last_name"];
   */
  lastName: string;

  /**
   * @generated from field: optional string phone_number = 5 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email: string;

  /**
   * @generated from field: required string password = 7;
   */
  password: string;

  /**
   * @generated from field: optional string driver_license_number = 8 [json_name = "driver_license_number"];
   */
  driverLicenseNumber: string;

  /**
   * @generated from field: optional string fcm_token = 9 [json_name = "fcm_token"];
   */
  fcmToken: string;

  /**
   * @generated from field: optional string registration_token = 10 [json_name = "registration_token"];
   */
  registrationToken: string;
};

/**
 * @generated from message raccoonai.UserCreate
 */
export type UserCreateJson = {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role?: UserRoleJson;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string first_name = 3 [json_name = "first_name"];
   */
  first_name?: string;

  /**
   * @generated from field: optional string last_name = 4 [json_name = "last_name"];
   */
  last_name?: string;

  /**
   * @generated from field: optional string phone_number = 5 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: required string password = 7;
   */
  password?: string;

  /**
   * @generated from field: optional string driver_license_number = 8 [json_name = "driver_license_number"];
   */
  driver_license_number?: string;

  /**
   * @generated from field: optional string fcm_token = 9 [json_name = "fcm_token"];
   */
  fcm_token?: string;

  /**
   * @generated from field: optional string registration_token = 10 [json_name = "registration_token"];
   */
  registration_token?: string;
};

/**
 * Describes the message raccoonai.UserCreate.
 * Use `create(UserCreateSchema)` to create a new message.
 */
export const UserCreateSchema: GenMessage<UserCreate, {jsonType: UserCreateJson}> = /*@__PURE__*/
  messageDesc(file_user, 1);

/**
 * @generated from message raccoonai.UserUpdate
 */
export type UserUpdate = Message<"raccoonai.UserUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional string first_name = 3 [json_name = "first_name"];
   */
  firstName: string;

  /**
   * @generated from field: optional string last_name = 4 [json_name = "last_name"];
   */
  lastName: string;

  /**
   * @generated from field: optional string phone_number = 5 [json_name = "phone_number"];
   */
  phoneNumber: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email: string;

  /**
   * @generated from field: optional raccoonai.UserStatus status = 7;
   */
  status: UserStatus;

  /**
   * @generated from field: optional string driver_license_number = 8 [json_name = "driver_license_number"];
   */
  driverLicenseNumber: string;

  /**
   * @generated from field: optional string fcm_token = 9 [json_name = "fcm_token"];
   */
  fcmToken: string;

  /**
   * @generated from field: optional raccoonai.UserRole role = 10;
   */
  role: UserRole;
};

/**
 * @generated from message raccoonai.UserUpdate
 */
export type UserUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional string first_name = 3 [json_name = "first_name"];
   */
  first_name?: string;

  /**
   * @generated from field: optional string last_name = 4 [json_name = "last_name"];
   */
  last_name?: string;

  /**
   * @generated from field: optional string phone_number = 5 [json_name = "phone_number"];
   */
  phone_number?: string;

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: optional raccoonai.UserStatus status = 7;
   */
  status?: UserStatusJson;

  /**
   * @generated from field: optional string driver_license_number = 8 [json_name = "driver_license_number"];
   */
  driver_license_number?: string;

  /**
   * @generated from field: optional string fcm_token = 9 [json_name = "fcm_token"];
   */
  fcm_token?: string;

  /**
   * @generated from field: optional raccoonai.UserRole role = 10;
   */
  role?: UserRoleJson;
};

/**
 * Describes the message raccoonai.UserUpdate.
 * Use `create(UserUpdateSchema)` to create a new message.
 */
export const UserUpdateSchema: GenMessage<UserUpdate, {jsonType: UserUpdateJson}> = /*@__PURE__*/
  messageDesc(file_user, 2);

/**
 * @generated from message raccoonai.UserUpdateRole
 */
export type UserUpdateRole = Message<"raccoonai.UserUpdateRole"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required raccoonai.UserRole role = 2;
   */
  role: UserRole;
};

/**
 * @generated from message raccoonai.UserUpdateRole
 */
export type UserUpdateRoleJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required raccoonai.UserRole role = 2;
   */
  role?: UserRoleJson;
};

/**
 * Describes the message raccoonai.UserUpdateRole.
 * Use `create(UserUpdateRoleSchema)` to create a new message.
 */
export const UserUpdateRoleSchema: GenMessage<UserUpdateRole, {jsonType: UserUpdateRoleJson}> = /*@__PURE__*/
  messageDesc(file_user, 3);

/**
 * @generated from message raccoonai.UserPasswordSet
 */
export type UserPasswordSet = Message<"raccoonai.UserPasswordSet"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required string new_password = 3 [json_name = "new_password"];
   */
  newPassword: string;
};

/**
 * @generated from message raccoonai.UserPasswordSet
 */
export type UserPasswordSetJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required string new_password = 3 [json_name = "new_password"];
   */
  new_password?: string;
};

/**
 * Describes the message raccoonai.UserPasswordSet.
 * Use `create(UserPasswordSetSchema)` to create a new message.
 */
export const UserPasswordSetSchema: GenMessage<UserPasswordSet, {jsonType: UserPasswordSetJson}> = /*@__PURE__*/
  messageDesc(file_user, 4);

/**
 * @generated from message raccoonai.RegistrationTokenCreate
 */
export type RegistrationTokenCreate = Message<"raccoonai.RegistrationTokenCreate"> & {
  /**
   * @generated from field: required string token = 1;
   */
  token: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.UserRole role = 3;
   */
  role: UserRole;

  /**
   * @generated from field: required google.protobuf.Timestamp expires_at = 4 [json_name = "expires_at"];
   */
  expiresAt?: Timestamp;

  /**
   * @generated from field: required uint64 created_by_user_id = 5 [json_name = "created_by_user_id"];
   */
  createdByUserId: bigint;

  /**
   * @generated from field: optional bool is_used = 6 [json_name = "is_used"];
   */
  isUsed: boolean;
};

/**
 * @generated from message raccoonai.RegistrationTokenCreate
 */
export type RegistrationTokenCreateJson = {
  /**
   * @generated from field: required string token = 1;
   */
  token?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.UserRole role = 3;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: required google.protobuf.Timestamp expires_at = 4 [json_name = "expires_at"];
   */
  expires_at?: TimestampJson;

  /**
   * @generated from field: required uint64 created_by_user_id = 5 [json_name = "created_by_user_id"];
   */
  created_by_user_id?: string;

  /**
   * @generated from field: optional bool is_used = 6 [json_name = "is_used"];
   */
  is_used?: boolean;
};

/**
 * Describes the message raccoonai.RegistrationTokenCreate.
 * Use `create(RegistrationTokenCreateSchema)` to create a new message.
 */
export const RegistrationTokenCreateSchema: GenMessage<RegistrationTokenCreate, {jsonType: RegistrationTokenCreateJson}> = /*@__PURE__*/
  messageDesc(file_user, 5);

/**
 * @generated from message raccoonai.RegistrationTokenUpdate
 */
export type RegistrationTokenUpdate = Message<"raccoonai.RegistrationTokenUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required bool is_used = 2 [json_name = "is_used"];
   */
  isUsed: boolean;
};

/**
 * @generated from message raccoonai.RegistrationTokenUpdate
 */
export type RegistrationTokenUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required bool is_used = 2 [json_name = "is_used"];
   */
  is_used?: boolean;
};

/**
 * Describes the message raccoonai.RegistrationTokenUpdate.
 * Use `create(RegistrationTokenUpdateSchema)` to create a new message.
 */
export const RegistrationTokenUpdateSchema: GenMessage<RegistrationTokenUpdate, {jsonType: RegistrationTokenUpdateJson}> = /*@__PURE__*/
  messageDesc(file_user, 6);

/**
 * @generated from message raccoonai.GenerateLink
 */
export type GenerateLink = Message<"raccoonai.GenerateLink"> & {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role: UserRole;

  /**
   * @generated from field: required int32 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: number;

  /**
   * @generated from field: required string preferred_method = 3 [json_name = "preferred_method"];
   */
  preferredMethod: string;

  /**
   * @generated from field: required string recipient = 4;
   */
  recipient: string;

  /**
   * @generated from field: required string lang = 5;
   */
  lang: string;
};

/**
 * @generated from message raccoonai.GenerateLink
 */
export type GenerateLinkJson = {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: required int32 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: number;

  /**
   * @generated from field: required string preferred_method = 3 [json_name = "preferred_method"];
   */
  preferred_method?: string;

  /**
   * @generated from field: required string recipient = 4;
   */
  recipient?: string;

  /**
   * @generated from field: required string lang = 5;
   */
  lang?: string;
};

/**
 * Describes the message raccoonai.GenerateLink.
 * Use `create(GenerateLinkSchema)` to create a new message.
 */
export const GenerateLinkSchema: GenMessage<GenerateLink, {jsonType: GenerateLinkJson}> = /*@__PURE__*/
  messageDesc(file_user, 7);

/**
 * @generated from message raccoonai.PasswordUpdate
 */
export type PasswordUpdate = Message<"raccoonai.PasswordUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string old_pwd = 2 [json_name = "old_pwd"];
   */
  oldPwd: string;

  /**
   * @generated from field: required string new_pwd = 3 [json_name = "new_pwd"];
   */
  newPwd: string;
};

/**
 * @generated from message raccoonai.PasswordUpdate
 */
export type PasswordUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string old_pwd = 2 [json_name = "old_pwd"];
   */
  old_pwd?: string;

  /**
   * @generated from field: required string new_pwd = 3 [json_name = "new_pwd"];
   */
  new_pwd?: string;
};

/**
 * Describes the message raccoonai.PasswordUpdate.
 * Use `create(PasswordUpdateSchema)` to create a new message.
 */
export const PasswordUpdateSchema: GenMessage<PasswordUpdate, {jsonType: PasswordUpdateJson}> = /*@__PURE__*/
  messageDesc(file_user, 8);

/**
 * @generated from message raccoonai.UserListRequest
 */
export type UserListRequest = Message<"raccoonai.UserListRequest"> & {
  /**
   * @generated from field: repeated raccoonai.UserRole roles = 1;
   */
  roles: UserRole[];

  /**
   * @generated from field: repeated raccoonai.UserStatus statuses = 2;
   */
  statuses: UserStatus[];

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.UserListRequest
 */
export type UserListRequestJson = {
  /**
   * @generated from field: repeated raccoonai.UserRole roles = 1;
   */
  roles?: UserRoleJson[];

  /**
   * @generated from field: repeated raccoonai.UserStatus statuses = 2;
   */
  statuses?: UserStatusJson[];

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.UserListRequest.
 * Use `create(UserListRequestSchema)` to create a new message.
 */
export const UserListRequestSchema: GenMessage<UserListRequest, {jsonType: UserListRequestJson}> = /*@__PURE__*/
  messageDesc(file_user, 9);

/**
 * @generated from message raccoonai.UserList
 */
export type UserList = Message<"raccoonai.UserList"> & {
  /**
   * @generated from field: repeated raccoonai.User users = 1;
   */
  users: User[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.UserList
 */
export type UserListJson = {
  /**
   * @generated from field: repeated raccoonai.User users = 1;
   */
  users?: UserJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.UserList.
 * Use `create(UserListSchema)` to create a new message.
 */
export const UserListSchema: GenMessage<UserList, {jsonType: UserListJson}> = /*@__PURE__*/
  messageDesc(file_user, 10);

/**
 * @generated from message raccoonai.InviteUserRequest
 */
export type InviteUserRequest = Message<"raccoonai.InviteUserRequest"> & {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role: UserRole;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required raccoonai.PreferredMethod preferred_method = 3 [json_name = "preferred_method"];
   */
  preferredMethod: PreferredMethod;

  /**
   * @generated from field: required string recipient = 4;
   */
  recipient: string;

  /**
   * @generated from field: required string lang = 5;
   */
  lang: string;
};

/**
 * @generated from message raccoonai.InviteUserRequest
 */
export type InviteUserRequestJson = {
  /**
   * @generated from field: required raccoonai.UserRole role = 1;
   */
  role?: UserRoleJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required raccoonai.PreferredMethod preferred_method = 3 [json_name = "preferred_method"];
   */
  preferred_method?: PreferredMethodJson;

  /**
   * @generated from field: required string recipient = 4;
   */
  recipient?: string;

  /**
   * @generated from field: required string lang = 5;
   */
  lang?: string;
};

/**
 * Describes the message raccoonai.InviteUserRequest.
 * Use `create(InviteUserRequestSchema)` to create a new message.
 */
export const InviteUserRequestSchema: GenMessage<InviteUserRequest, {jsonType: InviteUserRequestJson}> = /*@__PURE__*/
  messageDesc(file_user, 11);

/**
 * @generated from message raccoonai.InviteUserResponse
 */
export type InviteUserResponse = Message<"raccoonai.InviteUserResponse"> & {
  /**
   * @generated from field: required raccoonai.ResponseStatus status = 1;
   */
  status: ResponseStatus;

  /**
   * @generated from field: required string registration_token = 2 [json_name = "registration_token"];
   */
  registrationToken: string;
};

/**
 * @generated from message raccoonai.InviteUserResponse
 */
export type InviteUserResponseJson = {
  /**
   * @generated from field: required raccoonai.ResponseStatus status = 1;
   */
  status?: ResponseStatusJson;

  /**
   * @generated from field: required string registration_token = 2 [json_name = "registration_token"];
   */
  registration_token?: string;
};

/**
 * Describes the message raccoonai.InviteUserResponse.
 * Use `create(InviteUserResponseSchema)` to create a new message.
 */
export const InviteUserResponseSchema: GenMessage<InviteUserResponse, {jsonType: InviteUserResponseJson}> = /*@__PURE__*/
  messageDesc(file_user, 12);

/**
 * @generated from enum raccoonai.PreferredMethod
 */
export enum PreferredMethod {
  /**
   * @generated from enum value: PREFERRED_METHOD_UNDEFINED = 0;
   */
  UNDEFINED = 0,

  /**
   * @generated from enum value: PREFERRED_METHOD_WHATSAPP = 1;
   */
  WHATSAPP = 1,

  /**
   * @generated from enum value: PREFERRED_METHOD_EMAIL = 2;
   */
  EMAIL = 2,

  /**
   * @generated from enum value: PREFERRED_METHOD_COPY = 3;
   */
  COPY = 3,
}

/**
 * @generated from enum raccoonai.PreferredMethod
 */
export type PreferredMethodJson = "PREFERRED_METHOD_UNDEFINED" | "PREFERRED_METHOD_WHATSAPP" | "PREFERRED_METHOD_EMAIL" | "PREFERRED_METHOD_COPY";

/**
 * Describes the enum raccoonai.PreferredMethod.
 */
export const PreferredMethodSchema: GenEnum<PreferredMethod, PreferredMethodJson> = /*@__PURE__*/
  enumDesc(file_user, 0);

